/** EUR/CNY exchange **/

import Ajax from 'superagent'
import { isNumber } from 'lodash'
import {CronJob} from 'cron'

let rate: number = 7.80
let timestamp = "never"

function updateRate() {
  Ajax.get("/api/exchangerate")
    .end((e, r) => {
      if (e) {
        console.error(e)
      }
      else {
        rate = r.body.rate
        timestamp = r.body.timestamp
        console.log(`Exchange rate: 1EUR = ${rate}CNY`)
      }
    })
}

let alreadyInitiated = false

export function init() {
  if (!alreadyInitiated) {
    alreadyInitiated = true

    updateRate()

    const job = new CronJob({
      cronTime: '0 0 */1 * * *',
      onTick: updateRate,
      start: true,
      timeZone: 'Europe/Madrid'
    })
  }
}

export function getRateEurYuan() { return rate }
export function getRateYuanEur() { return 1 / rate }
export function getTimestamp()   { return timestamp }

export function eur2yuan(e) { return isNumber(e) ? (e * rate) : 0 }
export function yuan2eur(y) { return isNumber(y) ? (y / rate) : 0 }
